module.exports = __webpack_public_path__ + "categories/icon-feature-calendar-ddb507a6281a7080d5d860a3b57ed959.svg";